var $2b811292d5c787da$exports = {};
$2b811292d5c787da$exports = {
    "valid": `Platn\xe9`
};


export {$2b811292d5c787da$exports as default};
//# sourceMappingURL=sk-SK.module.js.map
